var _path, _mask, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2498 8.28667V36C34.2498 37.7949 32.7947 39.25 30.9998 39.25H9C7.20507 39.25 5.75 37.7949 5.75 36V4C5.75 2.20508 7.20508 0.75 9 0.75H26.0445L34.2498 8.28667Z",
    stroke: "#DEDEDE",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_4822_5752",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5V9.5H26C25.4477 9.5 25 9.05229 25 8.5V1Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 1H33.5H25ZM33.5 11H26C24.6193 11 23.5 9.88071 23.5 8.5L26.5 8H33.5V11ZM26 11C24.6193 11 23.5 9.88071 23.5 8.5V1H26.5V8L26 11ZM33.5 1V9.5V1Z",
    fill: "#DEDEDE",
    mask: "url(#path-2-inside-1_4822_5752)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 20,
    width: 23,
    height: 12,
    rx: 2,
    fill: "#4956F4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.52961 25.598H6.62761C6.78961 25.598 6.94561 25.586 7.09561 25.562C7.24561 25.538 7.37761 25.493 7.49161 25.427C7.60561 25.355 7.69561 25.256 7.76161 25.13C7.83361 25.004 7.86961 24.839 7.86961 24.635C7.86961 24.431 7.83361 24.266 7.76161 24.14C7.69561 24.014 7.60561 23.918 7.49161 23.852C7.37761 23.78 7.24561 23.732 7.09561 23.708C6.94561 23.684 6.78961 23.672 6.62761 23.672H5.52961V25.598ZM4.11661 22.574H7.01461C7.41661 22.574 7.75861 22.634 8.04061 22.754C8.32261 22.868 8.55061 23.021 8.72461 23.213C8.90461 23.405 9.03361 23.624 9.11161 23.87C9.19561 24.116 9.23761 24.371 9.23761 24.635C9.23761 24.893 9.19561 25.148 9.11161 25.4C9.03361 25.646 8.90461 25.865 8.72461 26.057C8.55061 26.249 8.32261 26.405 8.04061 26.525C7.75861 26.639 7.41661 26.696 7.01461 26.696H5.52961V29H4.11661V22.574ZM11.5325 27.812H12.7925C12.9965 27.812 13.1945 27.779 13.3865 27.713C13.5785 27.647 13.7495 27.539 13.8995 27.389C14.0495 27.233 14.1695 27.032 14.2595 26.786C14.3495 26.54 14.3945 26.24 14.3945 25.886C14.3945 25.562 14.3615 25.271 14.2955 25.013C14.2355 24.749 14.1335 24.524 13.9895 24.338C13.8455 24.152 13.6535 24.011 13.4135 23.915C13.1795 23.813 12.8885 23.762 12.5405 23.762H11.5325V27.812ZM10.1195 22.574H12.8915C13.3055 22.574 13.6895 22.64 14.0435 22.772C14.4035 22.904 14.7125 23.102 14.9705 23.366C15.2345 23.63 15.4385 23.96 15.5825 24.356C15.7325 24.752 15.8075 25.217 15.8075 25.751C15.8075 26.219 15.7475 26.651 15.6275 27.047C15.5075 27.443 15.3245 27.785 15.0785 28.073C14.8385 28.361 14.5355 28.589 14.1695 28.757C13.8095 28.919 13.3835 29 12.8915 29H10.1195V22.574ZM16.7904 22.574H21.3084V23.762H18.2034V25.247H20.8944V26.345H18.2034V29H16.7904V22.574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.1fd0b7900d425b6da57954d5fc2c6092.svg";
export { ForwardRef as ReactComponent };